import { useEffect } from 'react';
import Routers from './Route';
import { installGlobalModalScrollRestore } from './_helper/modalScrollRestore';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import { LoaderProvider } from './_helper/LoaderContext';
import { ClinicProvider } from './_helper/ClinicProvider';
import { PrivilegeContextProvider } from './_helper/PrivilegeContext';
import { NotificationProvider } from './_helper/NotificationContext';
import { BrowserRouter } from 'react-router-dom';
import { PharmacyProvider } from './_helper/PharmacyProvider';
import { CurrencyProvider } from './_helper/CurrencyContext';
import { LicenseProvider } from './_helper/license/LicenseContext';
import ScrollToTop from './Components/Common/ScrollToTop';
import { enableSequentialToasts } from './utils/toastQueue';

// Show react-toastify messages one-by-one app-wide
enableSequentialToasts();

const App = () => {
  useEffect(() => installGlobalModalScrollRestore(), []);

  return (
    <div className='App'>
      <PharmacyProvider>
        <BrowserRouter basename="/">
          <ScrollToTop />
          <LicenseProvider>
            <CustomizerProvider>
              <AnimationThemeProvider>
                <ClinicProvider>
                  <CurrencyProvider>
                    <PrivilegeContextProvider>
                      <LoaderProvider>
                        <NotificationProvider>
                          <Routers />
                        </NotificationProvider>
                      </LoaderProvider>
                    </PrivilegeContextProvider>
                  </CurrencyProvider>
                </ClinicProvider>
              </AnimationThemeProvider>
            </CustomizerProvider>
          </LicenseProvider>
        </BrowserRouter>
      </PharmacyProvider>
    </div>
  );
};

export default App;
